<template>
  <li>
    <div class="payment__method">
      <input type="radio" :id="paymentMethod['code']" name="payment[method]" :value="paymentMethod['code']" :checked="isActiveMethod" @change="changeSelectedPaymentMethod"/>
      <label :for="paymentMethod['code']">
        <img v-if="iconUrl" v-lazy="iconUrl" width="68" height="44" :alt="paymentMethod['title']"/>
        <span class="_title">{{ paymentMethod['title'] }}</span>
        <span class="_sub">{{ paymentMethod['code'] === 'paynl_payment_ideal' ? $t('The most used payment method in The Netherlands') : $t('Without extra fees') }}</span>
      </label>
      <ValidationProvider class="payment__method__options" v-slot="{ errors, classes }" rules="required" tag="div" v-if="issuers.length" v-show="isActiveMethod" :disabled="!isActiveMethod" :name="$t('Bank')">
        <select v-model="selectedIssuer" @change="changeSelectedIssuer" :class="classes">
          <option value="" selected disabled>{{ $t('Choose your bank') }}</option>
          <option
              :selected="isActiveIssuer(issuer)"
              :key="issuer.code"
              :value="issuer.code"
              v-for="issuer in issuers"
              v-text="issuer.description"
          />
        </select>
        <span class="field-error" v-if="errors.length">{{ $t(errors[0]) }}</span>
      </ValidationProvider>
    </div>
  </li>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {extend, ValidationProvider} from 'vee-validate';
import {required} from "vee-validate/dist/rules";

extend('required', required);

  @Component({
    name: 'checkout-payment-methods-default',
    components: {
      ValidationProvider
    }
  })

  export default class extends Vue {
    @Prop({required: true}) private paymentMethod: object;
    @Prop() private selectedPaymentMethod: object;

    private selectedIssuer: string = '';

    private isActiveIssuer(issuers): boolean {
      return this.selectedIssuer['code'] === issuers['code'];
    }

    private get isActiveMethod(): boolean {
      return this.selectedPaymentMethod['code'] === this.paymentMethod['code'];
    }

    // Only methods with a committed icon asset get a logo; others render text-only.
    private get iconUrl(): string {
      const code = this.paymentMethod['code'] || '';
      const withIcon = [
        'banktransfer',
        'multisafepay_ideal',
        'multisafepay_klarna',
        'multisafepay_bancontact',
        'multisafepay_maestro',
        'multisafepay_mastercard',
        'multisafepay_sofort',
        'multisafepay_visa',
        'multisafepay_banktransfer',
      ];
      return withIcon.includes(code) ? `/area/web/default/assets/images/payment-icons/${code}.png` : '';
    }

    private get issuers(): Array<object> {
      const code = this.paymentMethod?.['code'];
      if (typeof code === 'string' && code.match(/ideal$/) && this.paymentMethod.hasOwnProperty('issuers')) {
        return this.paymentMethod['issuers'];
      }

      return [];
    }

    private changeSelectedPaymentMethod(): void {
      this.$store.commit('CheckoutPayment/CLEAR_PAYMENT_DETAILS');
      const code = this.paymentMethod['code'] || '';
      if (code === 'multisafepay_applepay' || code === 'multisafepay_googlepay') {
        this.$store.commit('CheckoutPayment/ADD_PAYMENT_DETAILS', {transaction_type: 'redirect'});
      }
      this.$store.dispatch('CheckoutPayment/setSelectedPaymentMethod', this.paymentMethod);
    }

    private changeSelectedIssuer(): void {
      this.$store.dispatch('CheckoutPayment/setSelectedPaymentIssuer', {code: this.selectedIssuer});
      // MultiSafepay reads issuer_id from the payment's additional data at place-order
      // time (the v2 ?issuer= redirect param no longer exists in the headless flow).
      this.$store.commit('CheckoutPayment/ADD_PAYMENT_DETAILS', {issuer_id: this.selectedIssuer});
    }
  }
</script>
